<template>
    <BreadCrumb PageTitle="Ajouter une validation queue" />
     <AddModalValidationQueue/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalValidationQueue from "@/components/ValidationQueue/AddModalValidationQueue.vue";
  
    export default defineComponent({
      name: "AddValidationQueuePage",
      components: {
        BreadCrumb,
        AddModalValidationQueue,
      },
    });
  </script>